export default {
  'positions.title': 'Gestionar Puestos',
};
